module.exports = __webpack_public_path__ + "img/senado-logo.0e095521.jpg";